import { createI18n } from "vue-i18n";
import de from "./de/translations.json";

const locale = "de";

const messages = {
  de,
};

const i18n = createI18n({
  legacy: true,
  locale,
  fallbackLocale: locale,
  messages,
});

i18n.supportedLanguages = ["de"];

export default i18n;
